// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

import App from './App'

import VueRouter from 'vue-router'
import ToggleButton from 'vue-js-toggle-button'
import VeeValidate from 'vee-validate';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import { routes, publicRoutes, superAdminRoute, clientAdminRoute, userRoute, employerAdminRoute, employerRoute, employerSheetOnlyRoute } from './routes.js'
import VueProgressBar from 'vue-progressbar'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

import i18n from './lang/i18n.js'

import "./utils/translater.js";
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.prototype.$language = localStorage.getItem('lang') || 'en';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import { Drag, Drop } from 'vue-drag-drop';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';       // Font Awesome CSS
import 'bootstrap/dist/js/bootstrap.min.js';          // Bootstrap JS
import 'jquery';                                      // jQuery
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
import datePicker from 'vue-bootstrap-datetimepicker';
window.$ = window.jQuery = require('jquery');
window.$ = window.jQuery = $;
import FullCalendar from 'vue-full-calendar';
import vueScrollto from 'vue-scrollto'
import store from './store/store.js'
import VueKeepScrollPosition from 'vue-keep-scroll-position'
import 'v-infinite-scroll/dist/v-infinite-scroll.css';
import en from 'vee-validate/dist/locale/en';
import es from 'vee-validate/dist/locale/es';
import fr from 'vee-validate/dist/locale/fr';
import VueAppleLogin from 'vue-apple-login';

import infiniteScroll from './directives/infiniteScroll';
import VInfiniteScroll from './components/VInfiniteScroll.vue';

export const bus = new Vue();

Vue.config.productionTip = false;

Vue.use(datePicker);
$.extend(true, $.fn.datetimepicker.defaults, {
    icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-check',
        clear: 'fa fa-trash',
        close: 'fa fa-times'
    }
});

Vue.use(ElementUI, {
    locale
});

Vue.use(VueKeepScrollPosition);
Vue.use(VueRouter);
Vue.use(i18n);
Vue.use(ToggleButton);
Vue.use(VeeValidate, {
    i18nRootKey: 'validations',
    i18n,
    dictionary: {
        en: {
            custom: {
                StartAddDate: {
                    required: 'Start Date field is empty'
                },
                StartEditDate: {
                    required: 'Start Date field is empty'
                },
                Event: {
                    required: 'Event name field is empty'
                },
                resetemail: {
                    required: 'Your email field is empty'
                },
                StartAddDate: {
                    required: 'Start field is empty'
                },
                end: {
                    required: 'End Date field is empty'
                },
                employerName: {
                    required: 'Employer name field is empty'
                },
                streetAddress: {
                    required: 'Address field is empty'
                },
                priphone: {
                    required: 'Phone number is empty'
                },
                userName: {
                    required: 'User name is required'
                },
                cnfPassword: {
                    required: 'Confirm password is required'
                },
                firstName: {
                    required: 'First name is required'
                },
                lastName: {
                    required: 'Last name is required'
                },
                streetAdd: {
                    required: 'Address field is empty'
                },
                cellPhone: {
                    required: 'Phone number must have minimum length 10',
                    digits: 'Phone number must have minimum length 10',
                },
                homePhone: {
                    required: 'Phone number must have minimum length 10',
                    digits: 'Phone number must have minimum length 10',
                },
                state_province: {
                    required: 'State/Province is empty'
                },
                postcode: {
                    required: 'Postal code is empty'
                },
                sendid: {
                    required: 'Send address is required'
                },
                startDate: {
                    required: 'Start Date is required'
                },
                endDate: {
                    required: 'End Date is required'
                },
                startTime: {
                    required: 'Start Time is required'
                },
                endTime: {
                    required: 'End Time is required'
                },
                createdBy: {
                    required: 'Please check your skills definitions of steward & dispatched by'
                },
                steward: {
                    required: 'Please check your skills definitions of steward & dispatched by'
                }

            }
        },
        es: {
            custom: {
                StartAddDate: {
                    required: 'El campo Fecha de inicio está vacío'
                },
                StartEditDate: {
                    required: 'El campo Fecha de inicio está vacío'
                },
                Event: {
                    required: 'El campo Nombre del evento está vacío'
                },
                resetemail: {
                    required: 'El campo de correo electrónico está vacío'
                },
                StartAddDate: {
                    required: 'El campo Inicio está vacío'
                },
                end: {
                    required: 'El campo Fecha de finalización está vacío'
                },
                employerName: {
                    required: 'El campo Nombre del empleador está vacío'
                },
                streetAddress: {
                    required: 'El campo de dirección está vacío'
                },
                priphone: {
                    required: 'El número de teléfono está vacío'
                },
                userName: {
                    required: 'Se requiere nombre de usuario'
                },
                cnfPassword: {
                    required: 'Se requiere confirmar contraseña'
                },
                firstName: {
                    required: 'Se requiere nombre'
                },
                lastName: {
                    required: 'Se requiere apellido'
                },
                streetAdd: {
                    required: 'El campo de dirección está vacío'
                },
                cellPhone: {
                    required: 'El número de teléfono debe tener una longitud mínima 10',
                    digits: 'El número de teléfono debe tener una longitud mínima 10',
                },
                homePhone: {
                    required: 'El número de teléfono debe tener una longitud mínima 10',
                    digits: 'El número de teléfono debe tener una longitud mínima 10',
                },
                state_province: {
                    required: 'Estado/Provincia está vacío'
                },
                postcode: {
                    required: 'El código postal está vacío'
                },
                sendid: {
                    required: 'Se requiere dirección de envío'
                },
                startDate: {
                    required: 'Se requiere fecha de inicio'
                },
                endDate: {
                    required: 'Se requiere fecha de finalización'
                },
                startTime: {
                    required: 'Se requiere hora de inicio'
                },
                endTime: {
                    required: 'Se requiere hora de finalización'
                },
                createdBy: {
                    required: 'Por favor, compruebe sus definiciones de habilidades de mayordomo y enviado por'
                },
                steward: {
                    required: 'Por favor, compruebe sus definiciones de habilidades de mayordomo y enviado por'
                }

            }
        },
        fr: {
            custom: {
                StartAddDate: {
                    required: 'Le champ Démarrer est vide'
                },
                StartEditDate: {
                    required: 'Le champ Démarrer est vide'
                },
                Event: {
                    required: 'Le champ Nom de l’événement est vide'
                },
                resetemail: {
                    required: 'Votre champ d’e-mail est vide'
                },
                StartAddDate: {
                    required: 'Le champ Démarrer est vide'
                },
                end: {
                    required: 'Le champ Date de fin est vide'
                },
                employerName: {
                    required: 'Le champ Nom de l’employeur est vide'
                },
                streetAddress: {
                    required: 'Le champ Adresse est vide'
                },
                priphone: {
                    required: 'Le numéro de téléphone est vide'
                },
                userName: {
                    required: 'Le nom d’utilisateur est requis'
                },
                cnfPassword: {
                    required: 'Confirmer que le mot de passe est requis'
                },
                firstName: {
                    required: 'Prénom requis'
                },
                lastName: {
                    required: 'Le nom de famille est requis'
                },
                streetAdd: {
                    required: 'Le champ Adresse est vide'
                },
                cellPhone: {
                    required: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                    digits: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                },
                homePhone: {
                    required: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                    digits: 'Le numéro de téléphone doit avoir une longueur minimale 10',
                },
                state_province: {
                    required: 'L’État/la province est vide'
                },
                postcode: {
                    required: 'Le code postal est vide'
                },
                sendid: {
                    required: 'L’adresse d’envoi est requise'
                },
                startDate: {
                    required: 'La date de début est requise'
                },
                endDate: {
                    required: 'La date de fin est requise'
                },
                startTime: {
                    required: 'L’heure de début est requise'
                },
                endTime: {
                    required: 'L’heure de fin est requise'
                },
                createdBy: {
                    required: 'S’il vous plaît vérifier vos définitions de compétences de steward & dispatched par'
                },
                steward: {
                    required: 'S’il vous plaît vérifier vos définitions de compétences de steward & dispatched par'
                }

            }
        },
        en,
        es,
        fr
    }
});
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(VueProgressBar, options);
Vue.use(VModal);
Vue.use(VTooltip);
Vue.use(FullCalendar);
Vue.component('drag', Drag);
Vue.component('drop', Drop);
Vue.component(VueCropper);
Vue.use(vueScrollto);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBngxxJ-H5reyDULmda4mWXJuyK1Hb6WTI',
    },
});
Vue.component('v-infinite-scroll', VInfiniteScroll);
Vue.directive('infinite-scroll', infiniteScroll);

let redirectUrl = window.location.href.split('#')[0];

Vue.use(VueAppleLogin, {
    clientId: 'com.callsteward.service-id',
    scope: 'name email',
    redirectURI: redirectUrl,
    usePopup: true,
    state: 'initial'
});

const router = new VueRouter({
    base: (process.env.NODE_ENV == "development") ? '/' : '/',
    routes,
});
let count = 0;
const options = {
    color: '#bffaf3',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'left',
    inverse: false
};

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function deviceDetector() {
    let userAgent = navigator.userAgent.toLowerCase();
    const check = (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");

    return ("desktop" != check ? !0 : !1);
}
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function updateViewport(isMobile) {
    const content = isMobile
        ? "width=1024"
        : "width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no";

    const existing = document.querySelector('meta[name="viewport"]');

    const newMeta = document.createElement("meta");
    // newMeta.name = 'viewport';
    newMeta.setAttribute("name", "viewport");

    if (existing) {
        existing.parentNode.replaceChild(newMeta, existing);
    } else {
        document.head.appendChild(newMeta);
    }

    // newMeta.content = content;
    newMeta.setAttribute("content", content);
}
  

router.beforeEach((to, from, next) => {
    const isMobile = deviceDetector();

    updateViewport(isMobile);
    if ((to.name == 'magicLink' || to.name == 'wishlistConfirm') && (getCookie('csLogin') != "" || getCookie('csLogin') != null)) {
        // #1151: wishlistConfirm is the public landing for a notify-wishlist
        // shortlink — same magic-link treatment so an already-logged-in
        // dispatcher (or any other session) doesn't get role-redirected
        // away before the confirm page mounts.
        setCookie('csLogin', "", 1);
        localStorage.clear();
    }
    if (getCookie('csLogin') !== "" && getCookie('csLogin') !== null) {
        let ch = getCookie('csLogin');
        switch (ch) {
            case 'super-admin':
                if (superAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/clientList');
                }
                break;

            case 'client-admin':
                if (clientAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/jobList');
                }
                break;

            case 'power-user':
            case 'power-user-minus':
                if (clientAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/jobList');
                }
                break;

            case "auditor":
                if (clientAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/jobList');
                }
                break;

            case 'employee':
                // #1559: a power steward keeps csLogin='employee' (so checkAccess
                // feature-gating is unchanged — NO over-grant), but is additionally
                // allowed the CallList route. The guard honors the separate
                // powerSteward=1 cookie here rather than elevating the role tier;
                // regular employees (powerSteward != 1) are still bounced.
                if (userRoute.indexOf(to.name) != -1 ||
                    (getCookie('powerSteward') == 1 && to.name === 'CallList')) {
                    next();
                } else {
                    if(count == 1) {
                        Vue.prototype.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                    }
                    if (from.name == 'actionLog') {
                        count += 1;
                    }
                    next('/schedule/' + btoa(store.getters.loggedInEmployeeId));
                }
                break;

            case 'employer-admin':
                if (employerAdminRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/employerJobList');
                }
                break;

            case 'employer':
                if (employerRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/employerJobList');
                }
                break;
            case 'employer-sheet-only':
                if (employerSheetOnlyRoute.indexOf(to.name) != -1) {
                    next();
                } else {
                    next('/employerJobList');
                }
                break;
            default:
                next('/pageNotFound');
        }
    } else if (publicRoutes.indexOf(to.name) != -1) {
        next();
    } else {
        next("/login");
    }
});
new Vue({
    el: '#app',
    router,
    i18n,
    components: {
        App
    },
    template: '<App/>'
})
